import { coreApi } from '$api'
import { StaffRole } from '$models'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'
import sortBy from 'lodash/sortBy'

/**
 * Get all Staff Role
 * @param includeDeleted - include the deleted staff roles
 * @returns Promise<StaffRole[]>
 */
export const getAll = async (
  includeDeleted: boolean = true
): Promise<StaffRole[]> => {
  const { hasTimePermission } = getActiveCompanySettings()

  if (!hasTimePermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: ['getAllStaffRoles', includeDeleted],
    queryFn: async () => {
      const roles = await coreApi.getStaffRoles(includeDeleted)
      return sortBy<StaffRole>(roles, 'name')
    },
  })
}
